import React from 'react';
import User from 'img/left-nav/user.svg';
import Phone from 'img/left-nav/phone.svg';
import Teachers from 'img/left-nav/teachers.svg';
import More from 'img/left-nav/more.svg';

import SelectedUser from 'img/left-nav/selected-user.svg';
import Selectedphone from 'img/left-nav/selected-phone.svg';
import SelectedTeachers from 'img/left-nav/selected-teachers.svg';
import SelectedMore from 'img/left-nav/selected-more.svg';

export const tabs = {
  CALENDER: 'classroomManagement',
  CHAT: 'chat',
  CLASSROOM: 'classroom',
  CONTACT_US: 'contact-us',
  EXAM_PERFORMANCE: 'exam',
  HELP: 'help',
  LEADS_MANAGEMENT: 'leadsManagement',
  LOGOUT: 'Logout',
  MORE: 'more',
  NOTIFICATION: 'notification',
  PROFILE: 'profile',
  STUDENTS: 'students',
  TEACHER: 'teacher',
  TEACHER_MAP: 'teacher-map',
};

export const moreOptionMenu = {
  CURRICULUM: 'Curriculum',
  CURRICULUM_ANALYTICS: 'Curriculum_Analytics',
  EVAL: 'Eval',
  PAYMENT_LINK: 'Payment_Link',
  PRICING_MANAGEMENT: 'Pricing_Management',
  RM_PORTAL: 'RM_Portal',
  STUDENT_DEMOS: 'Student_demos',
  STUDENT_PAYMENT: 'Student_Payment',
  TEACHER_CLASSROOMS: 'Teacher_Classrooms',
  USER_VIBES: 'User_Vibes',
  TEACHER_APPLICANTS: 'Teacher_Applicants',
  WORKBOOK_MANAGEMENT: 'Workbook_Management',
  LEARNOSITY_DASHBOARD: 'Learnosity_Dashboard',
  STUDENT_TRANSFER: 'Student_Transfer',
  CS_UTILS: 'CS_UTILS',
  CSM: 'CSM',
  AV_REVIEW_DASHBOARD: 'AV_Review_Dashboard',
  HALL_OF_FAME: 'Hall_Of_Fame',
  WEBSITE_METRICS: 'Website_Metrics',
};

export const MORE_OPTIONS = [
  {
    id: moreOptionMenu.HALL_OF_FAME,
    label: 'Hall of Fame',
    link: '/hall-of-fame',
  },
  {
    id: moreOptionMenu.CURRICULUM,
    label: 'Curriculum',
    link: '/curriculum-graph',
  },
  {
    id: moreOptionMenu.STUDENT_DEMOS,
    label: 'Student Demos',
    link: '/users/studentdemos',
  },
  {
    id: moreOptionMenu.PAYMENT_LINK,
    label: 'Payment Link',
    link: '/users/payments',
  },
  {
    id: moreOptionMenu.TEACHER_CLASSROOMS,
    label: 'Teacher Classrooms',
    link: '/users/teacher-classrooms',
  },
  {
    id: moreOptionMenu.CURRICULUM_ANALYTICS,
    label: 'Curriculum Analytics',
    link: '/curriculum-analytics',
  },
  {
    id: moreOptionMenu.STUDENT_PAYMENT,
    label: 'Student Payment',
    link: '/student-payments',
  },
  {
    id: moreOptionMenu.PRICING_MANAGEMENT,
    label: 'Pricing Management',
    link: '/pricing-management',
  },
  {
    id: moreOptionMenu.EVAL,
    label: 'Eval',
    link: '/eval',
  },
  {
    id: moreOptionMenu.USER_VIBES,
    label: 'User Vibe',
    link: '/user-vibe',
  },
  {
    id: moreOptionMenu.RM_PORTAL,
    label: 'RM Portal',
    link: '/users/parent-relationship-managers',
  },
  {
    id: moreOptionMenu.CSM,
    label: 'Customer Success Managers',
    link: '/users/csm',
  },
  {
    id: moreOptionMenu.TEACHER_APPLICANTS,
    label: 'Teacher Applicants',
    link: '/users/teacher-applicants',
  },
  {
    id: moreOptionMenu.WORKBOOK_MANAGEMENT,
    label: 'Workbook Management',
    link: '/workbook-management',
  },
  {
    id: moreOptionMenu.LEARNOSITY_DASHBOARD,
    label: 'Learnosity Dashboard',
    link: '/learnosity-item-updated',
  },
  {
    id: moreOptionMenu.STUDENT_TRANSFER,
    label: 'Student Transfer',
    link: '/student-transfer',
  },
  {
    id: moreOptionMenu.AV_REVIEW_DASHBOARD,
    label: 'AV Review Dashboard',
    link: '/av-reviews',
  },
  {
    id: moreOptionMenu.WEBSITE_METRICS,
    label: 'Website Metrics',
    link: '/website-metrics',
  },
];

const { STUDENTS, TEACHER, CONTACT_US, MORE } = tabs;

export const TABS = [
  {
    id: STUDENTS,
    label: 'Students',
    link: '/students/',
    startsWith: ['/students', '/students/', '/students/:id'],
    icon: <img width="24px" height="24px" src={User} alt="user" />,
    selectedIcon: <img src={SelectedUser} alt="user" />,
  },
  {
    id: TEACHER,
    label: 'Teachers',
    link: '/users/teachers',
    startsWith: ['/users/teachers/', '/teacher-form/', '/teacher-form/:teacherId'],
    icon: <img width="24px" height="24px" src={Teachers} alt="" />,
    selectedIcon: <img src={SelectedTeachers} alt="" />,
  },
  {
    id: CONTACT_US,
    label: 'Contact info',
    link: '/pii-info',
    startsWith: ['/pii-info/', "/pii-info/?activeTab='active tab'", '/student-pii/'],
    icon: <img width="24px" height="24px" src={Phone} alt="phone" />,
    selectedIcon: <img src={Selectedphone} alt="phone" />,
  },
  {
    id: MORE,
    label: 'More Options',
    icon: <img width="24px" height="24px" src={More} alt="dots" />,
    selectedIcon: <img src={SelectedMore} alt="dots" />,
  },
];
